// SIMEMP em desativação: o site mostra só o aviso e as solicitações do Ploomes, sem login.
// Para reabrir o sistema completo, o main.jsx volta a renderizar <App /> (ver comentário lá).
import "./PublicSite.css";
import { REQUEST_KINDS } from "./constants";
import DeactivationNotice from "./DeactivationNotice";
import PublicRequestsPage from "./PublicRequestsPage";

export default function PublicSite() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const kind = Object.keys(REQUEST_KINDS).find((k) => REQUEST_KINDS[k].path === path);
  if (kind) return <PublicRequestsPage kind={kind} />;
  return <DeactivationNotice />;
}
